import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MyContext } from "../../../MyContextApi";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  menuClasses,
} from "react-pro-sidebar";
import "../../../styles/ReactProSidebar.css";
import { generateHash } from "../../../API/hashUtil";
import ChatInterface from "../../CommonPage/ChatInterface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faDatabase,
  faNewspaper,
  faChartPie,
  faFileImport,
  faClockRotateLeft,
  faServer,
  faUserPlus,
  faCircleInfo,
  faCircleNodes,
  faFileCsv,
  faFaceSmile,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../context/AuthContext";

const ReactProSidebar = () => {
  const [theme, setTheme] = useState("light");
  const [hasImage, setHasImage] = useState(false);
  const token = localStorage.getItem("Token");

  const themes = {
    light: {
      sidebar: {
        backgroundColor: "#FFFFFF",
        color: "#0B2948",
        backdropFilter: "none",
      },
      menu: {
        hover: {
          background:
            "linear-gradient(135deg, rgba(53, 114, 239, 0.08) 0%, rgba(53, 114, 239, 0.04) 100%)",
          color: "#0B2948",
          boxShadow: "0px 2px 8px rgba(53, 114, 239, 0.12)",
          transform: "translateX(2px)",
        },
        selected: {
          background: "linear-gradient(135deg, #3572EF 0%, #2563EB 100%)",
          color: "#FFFFFF",
          borderLeft: "3px solid #1D4ED8",
        },
      },
    },
    dark: {
      sidebar: {
        backgroundColor: "#0B1929",
        color: "#FFFFFF",
        backdropFilter: "blur(10px)",
      },
      menu: {
        hover: {
          background: "rgba(53, 114, 239, 0.15)",
          color: "#FFFFFF",
          boxShadow: "0px 4px 12px rgba(53, 114, 239, 0.3)",
          transform: "translateX(2px)",
        },
        selected: {
          background: "linear-gradient(135deg, #3572EF 0%, #2563EB 100%)",
          color: "#FFFFFF",
          borderLeft: "3px solid #60A5FA",
        },
      },
    },
  };

  const {
    toggleButton,
    toggleAdduser,
    settoggleAdduser,
    sidebarPlatformName,
    setSelectedPlatform,
    setsidebarPlatformName,
    setIsSocialMediaDataCollapsed,
    isSocialMediaDataCollapsed,
    isSubMenuOpen,
    setIsSubMenuOpen,
    isSubMenuOpen2,
    setIsSubMenuOpen2,
    isSubMenuOpen3,
    setIsSubMenuOpen3,
    isSubMenuOpen4,
    setIsSubMenuOpen4,
    collapsed,
    setCollapsed,
    setAPISelect,
    setIsSubMenuOpenDataHub,
    isSubMenuOpenDataHub,
  } = useContext(MyContext);

  const { role: userRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef(null);

  const getIconStyle = (path, isActive, defaultColor) => ({
    color: isActive ? "#FFFFFF" : defaultColor,
    transition: "all 0.2s ease",
  });

  const syncCollapsedSubmenus = () => {
    try {
      if (!sidebarRef.current) return;
      const wrappers = sidebarRef.current.querySelectorAll(
        ".my-submenu-content.collapsed",
      );
      wrappers.forEach((wrap) => {
        const isOpen = wrap.classList.contains("open");
        if (!isOpen) {
          wrap.style.display = "none";
          wrap.style.visibility = "hidden";
          wrap.style.opacity = "0";
          wrap.style.height = "0";
          wrap.style.margin = "0";
          wrap.style.padding = "0";
          wrap.style.pointerEvents = "none";
        } else {
          wrap.style.display = "";
          wrap.style.visibility = "";
          wrap.style.opacity = "";
          wrap.style.height = "";
          wrap.style.margin = "";
          wrap.style.padding = "";
          wrap.style.pointerEvents = "";
        }
      });
    } catch (err) {
      // defensive: ignore DOM errors
    }
  };

  const handleClick = (isAddUser) => {
    settoggleAdduser(isAddUser);
  };

  const handleSidebarPlatformChange = (isAddUser, platform) => {
    settoggleAdduser(isAddUser);
    setsidebarPlatformName(platform);
  };

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleSubMenuToggle = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  const handleSubMenuToggle2 = () => {
    setIsSubMenuOpen2(!isSubMenuOpen2);
  };

  const handleSubMenuToggle3 = () => {
    setIsSubMenuOpen3(!isSubMenuOpen3);
  };

  const handleSubMenuToggle4 = () => {
    setIsSubMenuOpen4(!isSubMenuOpen4);
  };

  const currentTheme = themes[theme];

  const menuItemStyles = {
    root: {
      fontSize: "14px",
      fontWeight: 500,
      fontFamily:
        "'Host Grotesk', -apple-system, BlinkMacSystemFont, sans-serif",
      paddingLeft: "6px",
      paddingRight: "6px",
      paddingBottom: "2px",
      paddingTop: "2px",
      width: "98%",
    },
    icon: {
      color: "#3572EF",
      marginRight: collapsed ? "0px" : "10px",
      fontSize: "17px",
      transition: "color 0.2s ease",
    },
    menu: {
      height: "auto",
      paddingTop: "8px",
      paddingBottom: "8px",
    },
    subMenuContent: {
      /* CRITICAL: zero everything on the container.
         All styling goes to the CSS on the items inside.
         This prevents bounce on open/close. */
      background: "transparent",
      border: "none",
      padding: "0",
      margin: "0",
      boxShadow: "none",
    },
    button: {
      color: "#0B2948",
      position: "relative",
      fontSize: "14px",
      fontFamily:
        "'Host Grotesk', -apple-system, BlinkMacSystemFont, sans-serif",
      padding: "10px 12px",
      margin: "2px 8px",
      borderRadius: "10px",
      fontWeight: 500,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      transition: "background 0.2s ease, color 0.2s ease",
      /* NO transform transitions — they cause bounce */
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : 500,
      fontFamily: "'Host Grotesk', sans-serif",
      fontSize: "14px",
      paddingLeft: "2px",
      display: "block",
      transition: "font-weight 0.2s ease",
    }),
    SubMenuExpandIcon: {
      marginLeft: "auto",
    },
  };

  const sidebarContainerStyle = {
    height: "100vh",
    position: "relative",
    zIndex: 1,
    backgroundColor: "#FFFFFF",
  };

  // Only collapse when going to small screens, don't auto-expand
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1336) {
        setCollapsed(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setCollapsed]);

  useEffect(() => {
    syncCollapsedSubmenus();
    const el = sidebarRef.current;
    if (!el) return;
    const onClick = (e) => {
      setTimeout(() => {
        syncCollapsedSubmenus();
      }, 10);
    };
    el.addEventListener("click", onClick, { capture: true });
    const mo = new MutationObserver((mutations) => {
      syncCollapsedSubmenus();
    });
    mo.observe(el, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });
    return () => {
      el.removeEventListener("click", onClick, { capture: true });
      mo.disconnect();
    };
  }, [collapsed]);

  useEffect(() => {
    setTimeout(syncCollapsedSubmenus, 50);
  }, []);

  const handleSubMenuToggleDataHub = (open) => {
    setIsSubMenuOpenDataHub(open);
  };

  /* ─── Section label ─── */
  const SectionLabel = ({ children }) =>
    !collapsed ? (
      <div
        style={{
          padding: "14px 20px 8px",
          color: "#94A3B8",
          fontSize: "10px",
          fontFamily: "'Host Grotesk', sans-serif",
          textTransform: "uppercase",
          fontWeight: 800,
          letterSpacing: "1.4px",
        }}
      >
        {children}
      </div>
    ) : null;

  /* ─── Divider ─── */
  const SidebarDivider = () =>
    !collapsed ? (
      <div
        style={{
          margin: "10px 20px",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, rgba(53, 114, 239, 0.12), transparent)",
        }}
      />
    ) : null;

  return (
    <div
      id="my-sidebar"
      className="prosidebar"
      style={{
        ...currentTheme.sidebar,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        boxShadow:
          "2px 0 20px rgba(0, 0, 0, 0.05), 1px 0 0 rgba(53, 114, 239, 0.06)",
        transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        gridArea: "sidebar",
        zIndex: 1000,
        borderRight: "1px solid rgba(53, 114, 239, 0.06)",
        width: collapsed ? "80px" : "260px",
        minWidth: collapsed ? "80px" : "260px",
        maxWidth: collapsed ? "80px" : "260px",
        background: "linear-gradient(180deg, #FFFFFF 0%, #FAFBFD 100%)",
      }}
    >
      {/* Accent top bar */}
      <div
        style={{
          height: "3px",
          flexShrink: 0,
          background:
            "linear-gradient(90deg, #3572EF 0%, #2563EB 40%, #818CF8 100%)",
          boxShadow: "0 1px 6px rgba(53, 114, 239, 0.3)",
        }}
      />

      <div className="sidebar-container" style={sidebarContainerStyle}>
        <Sidebar
          ref={sidebarRef}
          collapsed={collapsed}
          collapsedWidth="80px"
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            border: "none",
          }}
          width="260px"
          backgroundColor="transparent"
          className={collapsed ? "ps-collapsed" : ""}
        >
          <div
            style={{
              height: "100vh",
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden",
              paddingTop: "20px",
            }}
          >
            <SectionLabel>Main Menu</SectionLabel>

            <Menu menuItemStyles={menuItemStyles} iconShape="square">
              {/* Dashboard */}
              <MenuItem
                icon={
                  <FontAwesomeIcon
                    icon={faChartLine}
                    style={{
                      ...getIconStyle(
                        "/dashboard",
                        isActiveLink("/dashboard") ||
                          isActiveLink("/dashboardSentiment") ||
                          (isActiveLink("/dashboardSection") && !toggleAdduser),
                        "#3572EF",
                      ),
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
                active={
                  isActiveLink("/dashboard") ||
                  isActiveLink("/dashboardSentiment") ||
                  isActiveLink("/dashboardSection")
                }
                onClick={() => {
                  handleClick(false);
                  navigate("/dashboard");
                }}
              >
                Dashboard
              </MenuItem>

              {/* Data Hub */}
                    <MenuItem
                active={
                  isActiveLink("/socialMediaCrawler") ||
                  isActiveLink("/crawledImage") ||
                  isActiveLink("/audioAnalysis")
                }
                onClick={() => {
                  handleClick(false);
                  navigate("/socialMediaCrawler");
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faDatabase}
                    style={{
                      ...getIconStyle(
                        "/socialMediaCrawler",
                        isActiveLink("/socialMediaCrawler") ||
                          isActiveLink("/crawledImage") || isActiveLink("/audioAnalysis"),
                        "#3572EF",
                      ),
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
              >
                Data Hub
              </MenuItem>
              {/* <SubMenu
                label="Data Hub"
                icon={
                  <FontAwesomeIcon
                    icon={faDatabase}
                    style={{
                      color: "#3572EF",
                      transition: "all 0.2s ease",
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
                open={isSubMenuOpenDataHub}
                onOpenChange={handleSubMenuToggleDataHub}
              >
                <MenuItem
                  active={isActiveLink("/socialMediaCrawler")}
                  onClick={() => {
                    handleClick(false);
                    navigate("/socialMediaCrawler");
                  }}
                  icon={
                    <FontAwesomeIcon
                      icon={faDatabase}
                      style={{
                        ...getIconStyle(
                          "/socialMediaCrawler",
                          isActiveLink("/socialMediaCrawler"),
                          "#3572EF",
                        ),
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  Social Media Crawler
                </MenuItem>
                <MenuItem
                  active={isActiveLink("/sentimentCrawler")}
                  onClick={() => {
                    handleClick(false);
                    navigate("/sentimentCrawler");
                  }}
                  icon={
                    <FontAwesomeIcon
                      icon={faFaceSmile}
                      style={{
                        ...getIconStyle(
                          "/sentimentCrawler",
                          isActiveLink("/sentimentCrawler"),
                          "#3572EF",
                        ),
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  Sentiment Crawler
                </MenuItem> 
                <MenuItem
                  active={isActiveLink("/crawledImage")}
                  onClick={() => {
                    handleClick(false);
                    navigate("/crawledImage");
                  }}
                  icon={
                    <FontAwesomeIcon
                      icon={faDatabase}
                      style={{
                        ...getIconStyle(
                          "/crawledImage",
                          isActiveLink("/crawledImage"),
                          "#3572EF",
                        ),
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  Image Analysis
                </MenuItem>
              </SubMenu> */}

              {/* Topic Query */}
              <MenuItem
                active={isActiveLink("/automatedCrawler")}
                onClick={() => {
                  handleClick(false);
                  navigate("/automatedCrawler");
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faCircleNodes}
                    style={{
                      ...getIconStyle(
                        "/automatedCrawler",
                        isActiveLink("/automatedCrawler"),
                        "#3572EF",
                      ),
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
              >
                Topics
              </MenuItem>

              {/* News Hub */}
              <MenuItem
                active={
                  isActiveLink("/fakeNews") ||
                  isActiveLink("/factChecker") ||
                  isActiveLink("/newsSentiment")
                }
                onClick={() => {
                  handleClick(false);
                  navigate("/fakeNews");
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faNewspaper}
                    style={{
                      ...getIconStyle(
                        "/fakeNews",
                        isActiveLink("/fakeNews") ||
                          isActiveLink("/factChecker") ||
                          isActiveLink("/newsSentiment"),
                        "#3572EF",
                      ),
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
              >
                News Hub
              </MenuItem>

              <SidebarDivider />

              <SectionLabel>Reports</SectionLabel>
            <MenuItem
                active={
                  isActiveLink("/reportgen") ||
                  isActiveLink("/downloadHistory") 
                }
                onClick={() => {
                  handleClick(false);
                  navigate("/reportgen");
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faChartPie}
                    style={{
                      ...getIconStyle(
                        "/reportgen",
                        isActiveLink("/reportgen") ||
                          isActiveLink("/downloadHistory") ,
                        "#3572EF",
                      ),
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
              >
                Generate Reports
            
              </MenuItem>
              {/* Reports SubMenu */}
              {/* <SubMenu
                label="Reports"
                icon={
                  <FontAwesomeIcon
                    icon={faChartPie}
                    style={{
                      color: "#3572EF",
                      transition: "all 0.2s ease",
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
                open={isSubMenuOpen4}
                onOpenChange={handleSubMenuToggle4}
              >
                <MenuItem
                  active={isActiveLink("/reportgen")}
                  onClick={() => {
                    handleSidebarPlatformChange(false, "reportgen");
                    setAPISelect({
                      value: "api/filter",
                      label: "Social Media Report",
                    });
                    navigate("/reportgen");
                  }}
                  icon={
                    <FontAwesomeIcon
                      icon={faFileImport}
                      style={{
                        ...getIconStyle(
                          "/reportgen",
                          isActiveLink("/reportgen"),
                          "#3572EF",
                        ),
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  Create Report
                </MenuItem>
                <MenuItem
                  active={isActiveLink("/downloadHistory")}
                  onClick={() => {
                    handleSidebarPlatformChange(false, "downloadHistory");
                    navigate("/downloadHistory");
                  }}
                  icon={
                    <FontAwesomeIcon
                      icon={faClockRotateLeft}
                      style={{
                        ...getIconStyle(
                          "/downloadHistory",
                          isActiveLink("/downloadHistory"),
                          "#3572EF",
                        ),
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  Repository
                </MenuItem>
                <MenuItem
                  active={isActiveLink("/feedbackRepository")}
                  onClick={() => {
                    handleSidebarPlatformChange(false, "feedbackRepository");
                    navigate("/feedbackRepository");
                  }}
                  icon={
                    <FontAwesomeIcon
                      icon={faFileCsv}
                      style={{
                        ...getIconStyle(
                          "/feedbackRepository",
                          isActiveLink("/feedbackRepository"),
                          "#3572EF",
                        ),
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  Feedback Reports
                </MenuItem>
              </SubMenu> */}

              {/* Admin Section */}
              {userRole !== "ROLE_USER" && (
                <>
                  <SidebarDivider />
                  <SectionLabel>Administration</SectionLabel>

                  <MenuItem
                    active={isActiveLink("/crawledSessionRecords/All")}
                    onClick={() => {
                      handleClick(false);
                      navigate("/crawledSessionRecords/All");
                    }}
                    icon={
                      <FontAwesomeIcon
                        icon={faServer}
                        style={{
                          ...getIconStyle(
                            "/crawledSessionRecords/All",
                            isActiveLink("/crawledSessionRecords/All"),
                            "#3572EF",
                          ),
                          marginRight: !collapsed ? "0px" : "10px",
                        }}
                      />
                    }
                  >
                    Logs
                  </MenuItem>
                  <MenuItem
                    active={isActiveLink("/adduser")}
                    onClick={() => {
                      handleClick(true);
                      navigate("/adduser");
                    }}
                    icon={
                      <FontAwesomeIcon
                        icon={faUserPlus}
                        style={{
                          ...getIconStyle(
                            "/dashboard",
                            toggleAdduser,
                            "#3572EF",
                          ),
                          marginRight: !collapsed ? "-4px" : "4px",
                        }}
                      />
                    }
                  >
                    Add User
                  </MenuItem>
                </>
              )}

              <SidebarDivider />

              <MenuItem
                active={isActiveLink("/crawledInformation")}
                onClick={() => {
                  handleClick(false);
                  navigate("/crawledInformation");
                }}
                icon={
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    style={{
                      ...getIconStyle(
                        "/crawledInformation",
                        isActiveLink("/crawledInformation"),
                        "#3572EF",
                      ),
                      marginRight: !collapsed ? "0px" : "10px",
                    }}
                  />
                }
              >
                Info
              </MenuItem>
            </Menu>
          </div>
        </Sidebar>
      </div>
    </div>
  );
};

export default ReactProSidebar;